export default __webpack_public_path__ + "static/media/logo_youtube.79d64477.svg";